import { reactive, readonly } from 'vue'
import { projectFirestore } from '@/firebase/config'

const state = reactive({
  userData: null,
  characterData: null,
  characterPrivateData: null,
  loading: true,
  unsubscribers: []
})

const readonlyState = readonly(state)

let initialized = false

export function usePlayerStore () {
  const init = (userId) => {
    if (initialized || !userId) return
    initialized = true
    state.loading = true

    state.unsubscribers.push(
      projectFirestore.collection('users').doc(userId).onSnapshot(
        (snap) => {
          state.userData = snap.exists ? snap.data() : null
        },
        (err) => { console.error('usePlayerStore users error:', err) }
      )
    )

    state.unsubscribers.push(
      projectFirestore.collection('characters').doc(userId).onSnapshot(
        (snap) => {
          state.characterData = snap.exists ? snap.data() : null
        },
        (err) => { console.error('usePlayerStore characters error:', err) }
      )
    )

    state.unsubscribers.push(
      projectFirestore.collection('characterPrivate').doc(userId).onSnapshot(
        (snap) => {
          state.characterPrivateData = snap.exists ? snap.data() : null
          state.loading = false
        },
        (err) => {
          console.error('usePlayerStore characterPrivate error:', err)
          state.loading = false
        }
      )
    )
  }

  const cleanup = () => {
    state.unsubscribers.forEach((fn) => { if (fn) fn() })
    state.unsubscribers = []
    initialized = false
    state.userData = null
    state.characterData = null
    state.characterPrivateData = null
    state.loading = true
  }

  return {
    get userData () { return readonlyState.userData },
    get characterData () { return readonlyState.characterData },
    get characterPrivateData () { return readonlyState.characterPrivateData },
    get loading () { return readonlyState.loading },
    init,
    cleanup
  }
}
